import React from 'react';
import { badgeStyles } from 'utils/designSystem';

const Badge = ({ variant = 'neutral', children, style = {} }) => {
  return (
    <span style={{
      ...badgeStyles.base,
      ...badgeStyles[variant],
      ...style
    }}>
      {children}
    </span>
  );
};

export default Badge;